<div class="overLayDiv active"></div>
<div id="rightSideBar">
  <div class="rightSidePanel w-98pc active">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{headerText}}</h2>
      </div>            
      <div class="panel-left-btn">
          <button type="button" class="btn eod-btn-primary mr-2" (click)="downloadCSV()">
            {{"label_export"| translate:param}}
          </button>
          <button type="button" class="btn eod-btn-outline-warning" (click)="ClosePanel()">
            {{"Close"| translate:param}}
          </button>
      </div>
    </header>
    <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 margin-top-10 no-padding-right-left">
      <div class="block padding-top-10 overflow-auto heightCalc-5 scrollbar-visible">
        <div class="row mt-4">
          <div class="col-lg-2 padding-left-0">
            <div class="input-group categoryTemplate  z-index-101">
              <ng-select class="solo-dropdown claimantDropdown exportDropdown auditTrailDropdown" [items]="filterByList"
                bindLabel="filterByName" bindValue="filterById" placeholder="{{ 'filter_by' | translate }}" [selectOnTab]="true"
                [clearable]="false" [(ngModel)]="selectedFilterBy" name="selectedFilterBy"
                notFoundText="{{ 'no_data_available' | translate: param }}" (change)="onFilterByChange($event)">
              </ng-select>
            </div>
          </div>

          <div class="col-lg-2 padding-left-0" *ngIf="selectedFilterBy>0">
            <div class="input-group categoryTemplate  z-index-101">
              <ng-select class="solo-dropdown claimantDropdown multiSelectCategoryDropdown exportDropdown"
                [items]="filterList" [multiple]="true" bindLabel="name" groupBy="groupByField" [selectableGroup]="true"
                [selectableGroupAsModel]="false" [closeOnSelect]="false" bindValue="id" [clearable]="false"
                [placeholder]="selectedFilterByPlaceHolder" (change)="oncheckboxChange(2,$event)"
                [(ngModel)]="selectedFilterValues" notFoundText="{{ 'no_data_available' | translate: param }}"
                (open)="onOpen()">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div *ngIf="items.length != filterList.length">
                    <div class="ng-value" *ngFor="let item of items | slice: 0:1">
                      {{ item.name }}
                    </div>
                  </div>
                  <div *ngIf="items.length == filterList.length" class="ng-value">
                    {{ 'all' | translate}}
                  </div>
                  <div *ngIf="
                                      items.length != filterList.length &&
                                      items.length > 1
                                    " class="ng-value">
                    <span class="ng-value-label">(+{{ items.length - 1 }})</span>
                  </div>
                </ng-template>
                <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
                  <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" />
                  {{ 'all' | translate}}
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <input id="item-{{ index }}" type="checkbox" [ngModel]="item$.selected" (click)="oncheckboxChange(1,item)" />
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="col-lg-3 padding-left-0">
            <div class="input-group categoryTemplate z-index-101">
              <ng-select class="solo-dropdown claimantDropdown exportDropdown" [items]="paymentTypeList"
                bindLabel="name" bindValue="id" placeholder="{{ 'payment_type' | translate }}" [selectOnTab]="true"

                [clearable]="true" [(ngModel)]="selectedPaymentType" name="selectedPaymentType"
                notFoundText="{{ 'no_data_available' | translate: param }}" (change)="onPaymentTypeChange()">
              </ng-select>
            </div>
          </div>

          <div class="padding-left-0" [ngClass]="selectedFilterBy>0?'col-lg-2':'col-lg-4'">

            <button class="btn eod-btn-primary btn-sm fw-600 mr-2"
              [ngClass]="{'pointer-events-none': !enableViewButton}" (click)="filterGridData()">
              {{"view"| translate:param}}</button> 
              <button class="btn eod-btn-outline-warning-wbg eod-text-secondary btn-sm fw-600"
              (click)="resetFilters()">{{"reset"| translate:param}}</button>
          </div>


          <div class="col-lg-3 text-right table-total f-12 padding-right-0 padding-top-0">
            <span class="icon-themeColor fw-600">{{"claimant_count"| translate:param}}: {{claimantCount}}</span> <span
              class="text-charcoal-black d-block fw-600">{{"expenses_count"| translate:param}}: {{expenseCount}}</span>
          </div>

        </div>

        <div class="row mt-4">
          <div class="block heightCalc-13 padding-0">
            <app-grid [columns]="columnDefs" [data]="gridData" [gridFilterItems]="gridFilterItems"
              [gridConfigItems]="gridConfigItems">
            </app-grid>
          </div>



        </div>

      </div>
    </div>

  </div>
</div>